import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';

import { LiabilityAccounts } from './section/LiabilityAccounts';
import { BorrowingBaseMechanics } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/section/BorrowingBaseMechanics';
import { ClassMechanics } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/section/ClassMechanics';
import { Deliverables } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/section/Deliverables';
import { FacilityMechanics } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/section/FacilityMechanics';
import { FinancialCovenants } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/section/FinancialCovenants';
import { FundingRequestMechanics } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/section/FundingRequestMechanics';
import { Metadata } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/section/Metadata';
import { PortfolioCovenants } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/section/PortfolioCovenants';
import { ReportingDeliverablesDEPRECATED } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/section/ReportingDeliverablesDEPRECATED';
import { ReportingMechanics } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/section/ReportingMechanics';
import { SettlementMechanics } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/section/SettlementMechanics';
import {
  CreditAgreement,
  CreditAgreementFullArtifactWipConfigType,
} from 'packages/creditAgreements/ui/types';

type CreditAgreementFullArtifactProps = {
  organizationId: string;
  creditAgreementFullArtifact: CreditAgreement.DomainEntity.CreditAgreementFullArtifact;
  wipConfig?: CreditAgreementFullArtifactWipConfigType;
};
export const CreditAgreementFullArtifact = ({
  organizationId,
  creditAgreementFullArtifact,
  wipConfig,
}: CreditAgreementFullArtifactProps) => {
  const {
    creditFacilityId,
    borrowingBaseMechanics,
    classMechanics,
    fundingRequestMechanics,
    facilityMechanics,
    settlementMechanics,
    liabilityAccounts,
    financialCovenants,
    portfolioCovenants,
    reportingDeliverables,
    deliverables,
    reportingMechanics,
  } = creditAgreementFullArtifact;

  const { value: structure } = facilityMechanics.structure;

  const isStage = commonUtils.EnvUtils.isStage();
  const isProd = commonUtils.EnvUtils.isProduction();

  const borrowerSlug = facilityMechanics.parties.borrowers[0].entity.slug;

  // only show advance rate tree config on stage for valleyBank, everyone else should see advance rate formula config
  const showReceivableAdvanceRateTreeConfig =
    (isStage || isProd) && borrowerSlug === 'valleyBankBorrowers';

  return (
    <>
      <Metadata metadata={creditAgreementFullArtifact} wipConfig={wipConfig} />
      <FacilityMechanics
        facilityMechanics={facilityMechanics}
        wipConfig={wipConfig}
      />
      <FundingRequestMechanics
        fundingRequestMechanics={fundingRequestMechanics}
        wipConfig={wipConfig}
      />
      <ClassMechanics
        classMechanics={classMechanics}
        wipConfig={wipConfig}
        structure={structure}
      />
      <BorrowingBaseMechanics
        borrowingBaseMechanics={borrowingBaseMechanics}
        wipConfig={wipConfig}
        creditFacilityId={creditFacilityId}
        showReceivableAdvanceRateTreeConfig={
          showReceivableAdvanceRateTreeConfig
        }
      />
      <SettlementMechanics
        settlementMechanics={settlementMechanics}
        wipConfig={wipConfig}
      />
      <LiabilityAccounts
        liabilityAccounts={liabilityAccounts ?? []}
        wipConfig={wipConfig}
      />
      <FinancialCovenants
        organizationId={organizationId}
        financialCovenants={financialCovenants}
        wipConfig={wipConfig}
      />
      <PortfolioCovenants
        organizationId={organizationId}
        portfolioCovenants={portfolioCovenants}
        wipConfig={wipConfig}
      />
      <ReportingDeliverablesDEPRECATED
        reportingDeliverables={reportingDeliverables}
        wipConfig={wipConfig}
      />
      <ReportingMechanics
        organizationId={organizationId}
        reportingMechanics={reportingMechanics}
        wipConfig={wipConfig}
      />
      {/* v4 Deliverables */}
      <Deliverables deliverables={deliverables} wipConfig={wipConfig} />
    </>
  );
};
